import { useEffect, useState } from "react";
import { Button, Typography, Grid, CardContent, Card } from "@mui/material";
import { toast } from "react-toastify";
import { checkIfAdmin } from "../functions/helpers/user";
import { apiRequest } from "../functions/apiRequest";


export default function ProgramApproval() {

  const token = localStorage.getItem("token");
  const userID = localStorage.getItem("userID");
  const [data, setData] = useState([]);

  useEffect(() => {
    async function fetchData() {
      if (!(await checkIfAdmin(userID, token))) {
        window.location.href = '/';
      }
      const requests = await apiRequest('get', null, '/approval/pending/programs', token)
      setData(requests);
    }
    fetchData();
    // eslint-disable-next-line
  }, []);

  const CreditAddition = (infoData) => {
    fetch(
      process.env.REACT_APP_API_URL +
      `/api/program/update/${infoData.ProgramId}`,
      {
        method: "PUT",
        body: JSON.stringify({
          founder_Name: infoData.FounderName,
          program_name: infoData.ProgramName,
          program_description: infoData.ProgramDescription,
          start_date: infoData.StartDate,
          impact_int: infoData.ImpactInt,
          impact_units: infoData.ImpactUnits,
          impact_char: infoData.ImpactChar,
          redemption: ["Exchange", "Gift", "Certificate"],
          images: infoData.Images,
          approval_status: true,
        }),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Token ${token}`,
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 200) {
          toast.success("Updated successfully");
          window.location.href = "/programs/approvals";
        }
      })
      .catch((err) => {
        //console.log(err, "err");
      });
  };


  const RejectProgram = (infoData) => {
    fetch(
      process.env.REACT_APP_API_URL +
      `/api/program/update/${infoData.ProgramId}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Token ${token}`,
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 200) {
          toast.success("Updated successfully");
          window.location.href = "/programs/approvals";
        }
      })
      .catch((err) => {
        //console.log(err, "err");
      });
  };


  const handleSubmit = (id) => {
    //console.log(id);
  };
  return (
    <>
      <Grid container style={{ textAlign: "left", marginTop: 40 }}>
        {data.length > 0
          ? data.map((info, idx) => {
            return (
              <Grid item md={4} key={idx}>
                <Card style={{ marginLeft: 15, marginRight: 15 }}>
                  <CardContent>
                    <Grid container>
                      <Grid item xs={12}>
                        <Typography> From: {info.FounderName} </Typography>{" "}
                      </Grid>
                      <Grid item xs={12}>
                        <Typography> Program: {info.ProgramName} </Typography>{" "}
                      </Grid>
                      <br></br>
                      <Grid container style={{ marginTop: 12 }}>
                        <Grid item xs={12}>
                          <Typography>
                            {" "}
                            Program Description {
                              info.ProgramDescription
                            }{" "}
                          </Typography>{" "}
                        </Grid>
                        <Grid item xs={12}>
                          <Typography> Date: {info.StartDate}</Typography>{" "}
                        </Grid>

                        <Grid
                          item
                          xs={12}
                          style={{ justifyContent: "center" }}
                        >
                          {" "}
                          <br></br>
                          <Button
                            onClick={() => {
                              CreditAddition(info);
                            }}
                          >
                            <i
                              className="material-icons"
                              style={{ color: "green" }}
                            >
                              check_circle
                            </i>
                          </Button>{" "}
                          <Button
                            onClick={() => {
                              handleSubmit(info.id);
                              RejectProgram(info);
                            }}
                          >
                            <i
                              className="material-icons"
                              style={{ color: "red" }}
                            >
                              cancel
                            </i>
                          </Button>{" "}
                        </Grid>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            );
          })
          : ""}
      </Grid>
    </>
  );
}
